__turbopack_context__.v({
  "loadingBackdrop": "dfFYHW_loadingBackdrop",
  "loadingBackdropAbsolute": "dfFYHW_loadingBackdropAbsolute",
  "loadingBackdropCard": "dfFYHW_loadingBackdropCard",
  "text": "dfFYHW_text",
});
